import memoize from "lodash.memoize";

const createSelectorsFor = domain => ({
  getSortField: state => state.sorting[domain].field,
  getSortType: state => state.sorting[domain].type
});

export const selectorsFor = memoize(createSelectorsFor);
